import {
  ServiceTemplateListResponseSchema,
  ServiceTemplatePublishPreviewSchema,
  ServiceTemplateVersionDetailSchema,
  ServiceTemplateWriteResponseSchema,
  type CloneServiceTemplateRequest,
  type CreateServiceTemplateDraftRequest,
  type ServiceTemplateListResponse,
  type ServiceTemplatePublishPreview,
  type ServiceTemplateStatus,
  type ServiceTemplateVersionDetail,
  type ServiceTemplateWriteResponse,
  type UpdateServiceTemplateDraftRequest,
} from '@youkuai/contracts';

import { apiRequest } from './project-api.ts';

export async function listServiceTemplates(token: string, input: { search?: string; status?: ServiceTemplateStatus;
  archived?: boolean; afterId?: string }): Promise<ServiceTemplateListResponse> {
  const query = new URLSearchParams({ limit: '50' });
  if (input.search) query.set('search', input.search);
  if (input.status) query.set('status', input.status);
  if (input.archived !== undefined) query.set('archived', String(input.archived));
  if (input.afterId) query.set('afterId', input.afterId);
  return ServiceTemplateListResponseSchema.parse(await apiRequest(`/service-templates?${query}`, token));
}

export async function getServiceTemplate(token: string, versionId: string): Promise<ServiceTemplateVersionDetail> {
  return ServiceTemplateVersionDetailSchema.parse(await apiRequest(
    `/service-templates/${encodeURIComponent(versionId)}`, token));
}

export async function previewServiceTemplatePublish(token: string,
  versionId: string): Promise<ServiceTemplatePublishPreview> {
  return ServiceTemplatePublishPreviewSchema.parse(await apiRequest(
    `/service-templates/${encodeURIComponent(versionId)}/publish-preview`, token));
}

export async function createServiceTemplate(token: string, input: CreateServiceTemplateDraftRequest,
  idempotencyKey: string): Promise<ServiceTemplateWriteResponse> {
  return ServiceTemplateWriteResponseSchema.parse(await apiRequest('/service-template-drafts', token, {
    method: 'POST', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': idempotencyKey },
    body: JSON.stringify(input),
  }));
}

export async function updateServiceTemplate(token: string, versionId: string,
  input: UpdateServiceTemplateDraftRequest, idempotencyKey: string): Promise<ServiceTemplateWriteResponse> {
  return ServiceTemplateWriteResponseSchema.parse(await apiRequest(
    `/service-templates/${encodeURIComponent(versionId)}/draft`, token, {
      method: 'PUT', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': idempotencyKey },
      body: JSON.stringify(input),
    }));
}

export async function cloneServiceTemplate(token: string, versionId: string,
  input: CloneServiceTemplateRequest, idempotencyKey: string): Promise<ServiceTemplateWriteResponse> {
  return ServiceTemplateWriteResponseSchema.parse(await apiRequest(
    `/service-templates/${encodeURIComponent(versionId)}/clone`, token, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': idempotencyKey },
      body: JSON.stringify(input),
    }));
}

export async function publishServiceTemplate(token: string, versionId: string, expectedVersion: number,
  idempotencyKey: string): Promise<ServiceTemplateWriteResponse> {
  return ServiceTemplateWriteResponseSchema.parse(await apiRequest(
    `/service-templates/${encodeURIComponent(versionId)}/publish`, token, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Idempotency-Key': idempotencyKey },
      body: JSON.stringify({ expectedVersion }),
    }));
}
